import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Phone, Menu, X, ChevronDown } from "lucide-react";
import { MODELS, SITE } from "@/data/content";

const Header = () => {
  const [open, setOpen] = useState(false);
  const [submenuOpen, setSubmenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setOpen(false);
    setSubmenuOpen(false);
  }, [location.pathname]);

  return (
    <header className="rb-header" data-testid="site-header">
      <div className="container-rb rb-header__inner">
        <Link to="/" className="rb-logo" data-testid="logo-link" aria-label="RB TIM početna">
          <img
            src="/images/logo-rbtim.png"
            alt="RB TIM logo"
            className="rb-logo__img"
          />
      </Link>

        <nav className="rb-nav" aria-label="Glavna navigacija">
          <NavLink to="/" end className={({ isActive }) => `rb-nav__link ${isActive ? "active" : ""}`} data-testid="nav-home">
            Početna
          </NavLink>

          <div className="rb-nav__dropdown" data-testid="nav-models-dropdown">
            <NavLink
              to="/modeli-kontejnera"
              className={({ isActive }) => `rb-nav__link ${isActive ? "active" : ""}`}
              data-testid="nav-models"
            >
              Modeli kontejnera <ChevronDown size={14} />
            </NavLink>
            <div className="rb-nav__menu" role="menu">
              {MODELS.map((m) => (
                <NavLink key={m.slug} to={`/${m.slug}`} role="menuitem" data-testid={`nav-model-${m.key}`}>
                  {m.title}
                </NavLink>
              ))}
            </div>
          </div>

          <NavLink to="/galerija" className={({ isActive }) => `rb-nav__link ${isActive ? "active" : ""}`} data-testid="nav-gallery">
            Galerija
          </NavLink>
          <NavLink to="/o-nama" className={({ isActive }) => `rb-nav__link ${isActive ? "active" : ""}`} data-testid="nav-about">
            O nama
          </NavLink>
          <NavLink to="/kontakt" className={({ isActive }) => `rb-nav__link ${isActive ? "active" : ""}`} data-testid="nav-contact">
            Kontakt
          </NavLink>
        </nav>

        <div className="rb-header__cta">
          <a
            href={SITE.phoneHref}
            className="btn btn-primary"
            data-testid="cta-call"
            data-call-source="header-desktop-call"
          >
            <Phone size={16} /> Pozovite nas
          </a>
          <button
            type="button"
            className="rb-burger"
            onClick={() => setOpen((v) => !v)}
            aria-label={open ? "Zatvori meni" : "Otvori meni"}
            data-testid="nav-burger"
          >
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="rb-mobile" data-testid="mobile-menu">
          <Link to="/" data-testid="mobile-nav-home">Početna</Link>
          <button
            type="button"
            onClick={() => setSubmenuOpen((v) => !v)}
            data-testid="mobile-nav-models-toggle"
            style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}
          >
            <span>Modeli kontejnera</span>
            <ChevronDown size={16} style={{ transform: submenuOpen ? "rotate(180deg)" : "none", transition: "transform .2s" }} />
          </button>
          {submenuOpen && (
            <div className="rb-mobile__sub">
              <Link to="/modeli-kontejnera">Svi modeli</Link>
              {MODELS.map((m) => (
                <Link key={m.slug} to={`/${m.slug}`} data-testid={`mobile-nav-model-${m.key}`}>{m.title}</Link>
              ))}
            </div>
          )}
          <Link to="/galerija" data-testid="mobile-nav-gallery">Galerija</Link>
          <Link to="/o-nama" data-testid="mobile-nav-about">O nama</Link>
          <Link to="/kontakt" data-testid="mobile-nav-contact">Kontakt</Link>
          <a
            href={SITE.phoneHref}
            className="btn btn-primary"
            style={{ marginTop: 8 }}
            data-testid="mobile-cta-call"
            data-call-source="mobile-menu-call"
          >
            <Phone size={16} /> Pozovite nas
          </a>
        </div>
      )}
    </header>
  );
};

export default Header;
